import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_NUMBER = "971585900697";
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Hi Click Law, I would like to book a free consultation."
);

export default function WhatsAppButton() {
  return (
    <a
      className="cl-whatsapp"
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
}
